import React from 'react';
import { connect } from 'react-redux';
import { isEmpty } from 'lodash';
import { getPackageById } from '../../../../reducers/packages';
import { getValidExtras } from '../../../../utils/packagesUtils';
import FormGigItem from './FormGigItem';

const FormGigItems = ({ packageId, features, customExtras, extraFast }) => {
    const extras = getValidExtras({ features, customExtras, extraFast });

    if (isEmpty(extras)) {return null;}

    return extras.map(({ id, amount = 0 }, index) => (
        <FormGigItem key={index} packageId={packageId} id={id} quantity={amount}/>
    ));
};

const mapStateToProps = ({ packages }, { packageId }) => {
    const packageData = getPackageById(packages, packageId);
    const { features, customExtras, extraFast } = packageData;

    return {
        features,
        customExtras,
        extraFast
    };
};

export { FormGigItems };
export default connect(mapStateToProps)(FormGigItems);
